import type { QueryClient } from "@tanstack/react-query";

const SYNC_QUERY_ROOTS = new Set([
  "intervals-status", "sync-status", "dashboard", "history", "workouts", "workout",
  "workouts-calendar", "workouts-list", "planned-workout", "plan-workouts", "week",
  "profile", "onboarding-profile", "recovery-today", "body-history", "weekly-checkin",
  "nutrition-profile", "nutrition-weight-trend", "nutrition-summary", "nutrition-balance",
  "nutrition-day", "nutrition-week", "nutrition-week-inline", "nutrition-month", "nutrition-month-inline",
  "energy-availability", "hydration-today", "hydration-window",
]);

/** Discard older reads before reloading data that imports can change. */
export async function invalidateSyncData(client: QueryClient, current: () => boolean) {
  if (!current()) return;
  const filter = { predicate: (query: { queryKey: readonly unknown[] }) => SYNC_QUERY_ROOTS.has(String(query.queryKey[0])) };
  await client.cancelQueries(filter);
  if (current()) await client.invalidateQueries(filter);
}
